<app-candidate-register-form [candidateRegisterForm]="candidateRegisterForm"
                             [termsAndConditions]="termsAndConditions"
                             [countryRelatedCompaniesWithUniversalJob]="countryRelatedCompaniesWithUniversalJob"
                             [countries]="countries"
                             (countryChanged)="countryChanged()"
                             (companyChanged)="companyChanged()"
                             (formSubmitted)="checkIfCandidateAlreadyApplied($event)"></app-candidate-register-form>
